import { Icon, IconProps } from "./Icon";

export function IconEyeStrike(props: IconProps) {
  return (
    <Icon {...props}>
      <g fill="#232020" clipPath="url(#a)">
        <path d="m21.29 0-3.48 3.48A12.18 12.18 0 0 0 12 2C7.11 2 2.67 4.92.12 9.77L0 10l.12.25A15 15 0 0 0 5.29 16L2 19.29l.71.71L22 .71 21.29 0ZM1.13 10C3.52 5.62 7.57 3 12 3a11.13 11.13 0 0 1 5.07 1.23l-2.61 2.61A3.91 3.91 0 0 0 12.05 6a4 4 0 0 0-4 4 3.91 3.91 0 0 0 .84 2.41L6 15.28A13.9 13.9 0 0 1 1.13 10Zm8.47 1.69A2.92 2.92 0 0 1 9.05 10a3 3 0 0 1 3-3 2.92 2.92 0 0 1 1.69.55L9.6 11.69ZM12.05 13a3.11 3.11 0 0 1-.81-.12l-.79.78a3.89 3.89 0 0 0 1.6.34 4 4 0 0 0 4-4 3.89 3.89 0 0 0-.34-1.6l-.78.79c.07.26.12.54.12.81a3 3 0 0 1-3 3Zm7.49-8.42-.72.71a14.35 14.35 0 0 1 4 4.71c-2.39 4.39-6.43 7-10.86 7a11.19 11.19 0 0 1-4.1-.78l-.73.78A12.41 12.41 0 0 0 12 18c4.88 0 9.32-2.89 11.88-7.76L24 10l-.13-.23a15.31 15.31 0 0 0-4.33-5.19Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h24v20H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
